/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Button,
  Col,
  Row,
} from 'react-bootstrap';
import ShowIf from 'loracoms/ShowIf';
import HideIf from 'loracoms/HideIf';
import Checkbox from 'loracoms/Checkbox';
import Editable from 'loracoms/Editable';
import AutoColor from 'loracoms/AutoColor';
import FormBlock from 'loracoms/FormBlock';
import ErrorSet from 'lorautils/errors/ErrorSet';
import IntlMsg from 'lorautils/intl/IntlMsg';
import config from 'loracfg';
import appActions from 'loraactions/app';
import styles from './styles.scss';


const kTargets = [{
  label: 'none',
  value: '',
}, {
  label: 'HTTP Post',
  value: 'post',
}, {
  label: 'mqtt',
  value: 'mqtt',
}];

if (config.profile === 'cloud') {
  kTargets.push({
    label: 'senzFlow',
    value: 'senzflow',
  });
}

function parseToken(token) {
  const {
    s: serverUrl,
    t: topic,
    c: clientId,
    p: password,
    e,
  } = JSON.parse(token || '{}');
  let {
    u: pushUrl,
    u: username,
  } = JSON.parse(token || '{}');
  if (!_.isNil(topic) && topic !== '') {
    pushUrl = '';
  } else {
    username = '';
  }
  const appDataOnly = e === 'hex';
  return {
    pushUrl,
    appDataOnly,
    serverUrl,
    topic,
    clientId,
    username,
    password,
  };
}

const propTypes = {
  intl: React.PropTypes.object.isRequired,
  appState: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
  getApp: React.PropTypes.func.isRequired,
  updateApp: React.PropTypes.func.isRequired,
  updateState: React.PropTypes.object.isRequired,
};

class PushInterface extends React.Component {
  constructor(props) {
    super(props);
    const {
      data: {
        target,
        token,
      } = {},
    } = props.appState;
    this.state = {
      target,
      ...parseToken(token),
      editing: false,
      editData: {},
      errors: ErrorSet.createEmpty(),
      touched: new Set(),
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.apiview.pushinterface');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEnableEdit = this.handleEnableEdit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { appState, updateState } = nextProps;
    if (appState !== this.props.appState) {
      this.setState({ appState });
      if (appState.status === 'success') {
        const { target, token } = appState.data;
        this.setState({
          target,
          ...parseToken(token),
        });
      }
    }
    if (updateState !== this.props.updateState) {
      if (updateState.status === 'success') {
        const { getApp, appId } = this.props;
        getApp(appId).then(() => {
          this.setState({ editing: false });
        }).catch(() => {
          this.setState({ editing: false });
        });
      } else if (updateState.status === 'failure') {
        const { errors } = this.state;
        this.setState({
          errors: errors.add(updateState.error.code, 'submit'),
        });
      }
    }
  }

  handleEnableEdit() {
    const {
      target,
      pushUrl,
      appDataOnly,
      serverUrl,
      topic,
      clientId,
      username,
      password,
    } = this.state;
    let { errors } = this.state;
    if (target === 'post' && (pushUrl === '' || _.isNil(pushUrl))) {
      errors = errors.add('FE_EMPTY', 'pushurl');
    }
    if (target === 'mqtt' && (topic === '' || _.isNil(topic))) {
      errors = errors.add('FE_EMPTY', 'topic');
    }
    if (target === 'mqtt' && (serverUrl === '' || _.isNil(serverUrl))) {
      errors = errors.add('FE_EMPTY', 'serverUrl');
    }

    errors = errors.remove('submit');

    this.setState({
      editing: true,
      editData: {
        target,
        pushUrl,
        appDataOnly,
        serverUrl,
        topic,
        clientId,
        username,
        password,
      },
      errors,
    });
  }

  touchAll() {
    const { editData, touched } = this.state;
    if (editData.target === 'post') {
      touched.add('pushurl');
    } else if (editData.target === 'mqtt') {
      touched.add('topic')
        .add('serverUrl');
    }
    this.setState({ touched });
  }

  handleSubmit(e) {
    e.preventDefault();

    const { appId, updateApp } = this.props;
    const { editData = {} } = this.state;
    const {
      target,
      pushUrl,
      appDataOnly,
      serverUrl,
      topic,
      clientId,
      username,
      password,
    } = editData;

    let { errors } = this.state;
    errors = errors.remove('submit');
    this.setState({ errors });

    this.touchAll();
    if (!errors.isEmpty()) {
      return;
    }

    if (target === 'post') {
      const token = JSON.stringify({
        u: pushUrl,
        e: appDataOnly ? 'hex' : 'json',
      });
      updateApp(appId, { target, token });
    } else if (target === 'mqtt') {
      const token = JSON.stringify({
        s: serverUrl,
        t: topic,
        c: (!_.isNil(clientId) && clientId !== '') ? clientId : 'loraflow.io',
        u: !_.isNil(username) ? username : '',
        p: !_.isNil(password) ? password : '',
      });
      updateApp(appId, { target, token });
    } else {
      updateApp(appId, { target });
    }
  }

  handleChange(editData) {
    this.setState({
      editData,
      touched: new Set(),
    });

    let { errors } = this.state;
    errors = errors.remove('submit');
    if (editData.target === 'post' &&
      (editData.pushUrl === '' || _.isNil(editData.pushUrl))) {
      errors = errors.add('FE_EMPTY', 'pushurl');
      this.setState({ errors });
    } else {
      errors = errors.remove('pushurl');
      this.setState({ errors });
    }

    if (editData.target === 'mqtt' &&
      (editData.topic === '' || _.isNil(editData.topic))) {
      errors = errors.add('FE_EMPTY', 'topic');
      this.setState({ errors });
    } else {
      errors = errors.remove('topic');
      this.setState({ errors });
    }

    if (editData.target === 'mqtt' &&
      (editData.serverUrl === '' || _.isNil(editData.serverUrl))) {
      errors = errors.add('FE_EMPTY', 'serverUrl');
      this.setState({ errors });
    } else {
      errors = errors.remove('serverUrl');
      this.setState({ errors });
    }
  }

  render() {
    const {
      editing = false,
      editData = {},
      errors,
      touched,
    } = this.state;
    let {
      target,
      pushUrl,
      appDataOnly,
      serverUrl,
      topic,
      clientId,
      username,
      password,
    } = this.state;
    if (editing) {
      target = editData.target;
      pushUrl = editData.pushUrl;
      appDataOnly = editData.appDataOnly;
      serverUrl = editData.serverUrl;
      topic = editData.topic;
      clientId = editData.clientId;
      username = editData.username;
      password = editData.password;
    }

    if (_.isNil(clientId) || clientId === '') {
      editData.clientId = 'loraflow.io';
    }

    return (
      <Row>
        <Col md={5}>
          <Form horizontal className={styles.pushForm}>
            <FormGroup>
              <Col md={3}>
                <ControlLabel className="aisz-control-label">
                  {this.intlMsg.msg('label')}
                </ControlLabel>
              </Col>
              <Col md={6}>
                <Editable
                  edit={editing}
                  id="target"
                  value={target}
                  data={editData}
                  control={{
                    type: 'select',
                    options: kTargets,
                  }}
                  formatter={(x) => {
                    const targetOpt = kTargets.find(t => t.value === (x || ''));
                    let label = <i className="fa fa-spinner fa-spin" />;
                    if (targetOpt) {
                      label = targetOpt.label;
                    }
                    return (
                      <FormControl.Static>
                        <AutoColor content={x} inverse>
                          <i className="fa fa-circle" />{' '}
                        </AutoColor>
                        {label}
                      </FormControl.Static>
                    );
                  }}
                  onChange={this.handleChange}
                />
              </Col>
            </FormGroup>
            <ShowIf if={target === 'post' || editData.target === 'post'}>
              <FormGroup validationState={errors.has('pushurl') && touched.has('pushurl') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">URL</ControlLabel>
                </Col>
                <Col md={6}>
                  <Editable
                    edit={editing}
                    id="pushUrl"
                    value={pushUrl}
                    data={editData}
                    control={{ className: `aisz-form-control ${styles.urlInput}` }}
                    formatter={x => <FormControl.Static>{x}</FormControl.Static>}
                    onChange={this.handleChange}
                  />
                </Col>
              </FormGroup>
            </ShowIf>
            <ShowIf if={target === 'post' || editData.target === 'post'}>
              <FormGroup>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">
                    {this.intlMsg.msg('appdataonly.checkbox')}
                  </ControlLabel>
                </Col>
                <Col md={6}>
                  <div className={styles.chkbox}>
                    <Checkbox
                      id="appDataOnly"
                      checked={appDataOnly}
                      onChange={(checked) => {
                        this.setState({
                          editData: {
                            ...editData,
                            appDataOnly: checked,
                          },
                        });
                      }}
                      disabled={!editing}
                    />
                  </div>
                </Col>
              </FormGroup>
            </ShowIf>
            <ShowIf if={target === 'mqtt' || editData.target === 'mqtt'}>
              <FormGroup validationState={errors.has('serverUrl') && touched.has('serverUrl') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">URL *</ControlLabel>
                </Col>
                <Col md={6}>
                  <Editable
                    edit={editing}
                    id="serverUrl"
                    value={serverUrl}
                    data={editData}
                    control={{ className: `aisz-form-control ${styles.urlInput}` }}
                    formatter={x => <FormControl.Static>{x}</FormControl.Static>}
                    onChange={this.handleChange}
                  />
                </Col>
              </FormGroup>
            </ShowIf>
            <ShowIf if={target === 'mqtt' || editData.target === 'mqtt'}>
              <FormGroup validationState={errors.has('topic') && touched.has('topic') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">Topic *</ControlLabel>
                </Col>
                <Col md={6}>
                  <Editable
                    edit={editing}
                    id="topic"
                    value={topic}
                    data={editData}
                    control={{ className: `aisz-form-control ${styles.urlInput}` }}
                    formatter={x => <FormControl.Static>{x}</FormControl.Static>}
                    onChange={this.handleChange}
                  />
                </Col>
              </FormGroup>
            </ShowIf>
            <ShowIf if={target === 'mqtt' || editData.target === 'mqtt'}>
              <FormGroup>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">Client ID</ControlLabel>
                </Col>
                <Col md={6}>
                  <Editable
                    edit={editing}
                    id="clientId"
                    value={clientId}
                    data={editData}
                    control={{ className: `aisz-form-control ${styles.urlInput}` }}
                    formatter={x => <FormControl.Static>{x}</FormControl.Static>}
                    onChange={this.handleChange}
                  />
                </Col>
              </FormGroup>
            </ShowIf>
            <ShowIf if={target === 'mqtt' || editData.target === 'mqtt'}>
              <FormGroup>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">Username</ControlLabel>
                </Col>
                <Col md={6}>
                  <Editable
                    edit={editing}
                    id="username"
                    value={username}
                    data={editData}
                    control={{ className: `aisz-form-control ${styles.urlInput}` }}
                    formatter={x => <FormControl.Static>{x}</FormControl.Static>}
                    onChange={this.handleChange}
                  />
                </Col>
              </FormGroup>
            </ShowIf>
            <ShowIf if={target === 'mqtt' || editData.target === 'mqtt'}>
              <FormGroup>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">Password</ControlLabel>
                </Col>
                <Col md={6}>
                  <Editable
                    edit={editing}
                    id="password"
                    value={password}
                    data={editData}
                    control={{ className: `aisz-form-control ${styles.urlInput}` }}
                    formatter={x => <FormControl.Static>{x}</FormControl.Static>}
                    onChange={this.handleChange}
                  />
                </Col>
              </FormGroup>
            </ShowIf>
            <FormGroup>
              <Col mdOffset={3} md={12}>
                <ShowIf if={editing}>
                  <div>
                    <Button
                      bsStyle="aisz-warning"
                      onClick={() => { this.setState({ editing: false, editData: {} }); }}
                    >
                      {this.intlMsg.msg('cancel.btn')}
                      {' '}
                      <i className="fa fa-times" aria-hidden="true" />
                    </Button>
                    {' '}
                    <Button bsStyle="aisz-primary" onClick={this.handleSubmit}>
                      {this.intlMsg.msg('save.btn')}
                      {' '}
                      <i className="fa fa-check" aria-hidden="true" />
                    </Button>
                  </div>
                </ShowIf>
                <HideIf if={editing}>
                  <Button bsStyle="aisz-primary" onClick={this.handleEnableEdit}>
                    {this.intlMsg.msg('edit.btn')}
                    {' '}
                    <i className="fa fa-pencil-square-o" aria-hidden="true" />
                  </Button>
                </HideIf>
                <div className={styles.submitError}>
                  <FormBlock
                    show={errors.has('submit')}
                    message={this.intlMsg.errorMsg(errors.get('submit'))}
                    azStyle="danger"
                  />
                </div>
              </Col>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    );
  }
}

PushInterface.propTypes = propTypes;

const mapStateToProps = state => ({
  planState: state.billing.plan,
  appState: state.app.getApp,
  updateState: state.app.updateApp,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getApp: appActions.getApp,
  updateApp: appActions.updateApp,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PushInterface));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/APIView/coms/PushInterface/index.jsx